/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { GatewayRequestBuilderRequestsMetadata, type GatewayRequestBuilder } from './gateway/index.js';
// @ts-ignore
import { type WithCustomerNumberItemRequestBuilder, WithCustomerNumberItemRequestBuilderNavigationMetadata } from './item/index.js';
// @ts-ignore
import { PaymentMethodsRequestBuilderRequestsMetadata, type PaymentMethodsRequestBuilder } from './paymentMethods/index.js';
// @ts-ignore
import { type WorldpayRequestBuilder, WorldpayRequestBuilderNavigationMetadata } from './worldpay/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments
 */
export interface PaymentsRequestBuilder extends BaseRequestBuilder<PaymentsRequestBuilder> {
    /**
     * The gateway property
     */
    get gateway(): GatewayRequestBuilder;
    /**
     * The paymentMethods property
     */
    get paymentMethods(): PaymentMethodsRequestBuilder;
    /**
     * The worldpay property
     */
    get worldpay(): WorldpayRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.payments.item collection
     * @param customerNumber The customer number to get payment profiles for
     * @returns {WithCustomerNumberItemRequestBuilder}
     */
     byCustomerNumber(customerNumber: string) : WithCustomerNumberItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const PaymentsRequestBuilderUriTemplate = "{+baseurl}/api/payments";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PaymentsRequestBuilderNavigationMetadata: Record<Exclude<keyof PaymentsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byCustomerNumber: {
        navigationMetadata: WithCustomerNumberItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["customerNumber"],
    },
    gateway: {
        requestsMetadata: GatewayRequestBuilderRequestsMetadata,
    },
    paymentMethods: {
        requestsMetadata: PaymentMethodsRequestBuilderRequestsMetadata,
    },
    worldpay: {
        navigationMetadata: WorldpayRequestBuilderNavigationMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
